import styled from 'styled-components';
import { colors } from '../styles/variables';

const InventoryFooterView = styled.div`
display: flex;
align-items: center;
justify-content: flex-end;
padding: 8px;
.price-info {
  line-height: 1.3em;
  margin-right: 8px;
}
.discount-rate {
  font-size: 10px;
  font-weight: bold;
  background-color: ${colors.red};
  padding: 2px 6px;
  border-radius: 2px;
  color: ${colors.white};
  margin-right: 4px;
}
.discount-price {
  font-size: 13px;
  color: ${colors.red};
}
.total-price {
  text-align: right;
  .currency {
    font-size: 12px;
    color: ${colors.gray600};
    margin-right: 4px;
  }
  .amount {
    font-size: 16px;
    font-weight: bold;
  }
}
`;

export default InventoryFooterView;
